import * as vishnevskii from './static/img/r-vishnevskii.jpg';
import * as vishnevskiiBig from './static/img/r-vishnevskii_big.jpg';

import * as radchenko from './static/img/a-radchenko.jpg';
import * as radchenkoBig from './static/img/a-radchenko_big.jpg';

import * as belousov from './static/img/d-belousov.jpg';
import * as belousovBig from './static/img/d-belousov_big.jpg';

import * as kurdyukov from './static/img/a-kurdyukov.jpg';
import * as kurdyukovBig from './static/img/a-kurdyukov_big.jpg';

import * as butin from './static/img/y-butin.jpg';
import * as yuryev from './static/img/g-yuryev.jpg';
import * as ofitserova from './static/img/d-ofitserova.jpg';
import * as markov from './static/img/a-markov.jpg';
import * as klevtsov from './static/img/a-klevtsov.jpg';

export interface Partner {
  img: string;
  imgBig?: string;
  name: string;
  positionInCompany: string;
  info?: string[];
  followers?: number;
  channel?: string;
  channelLink?: string;
}

export const getPartners = (t: Function): Partner[] => [
  {
    img: vishnevskii,
    imgBig: vishnevskiiBig,
    name: t('Roman Vishnevskiy'),
    positionInCompany: t('Roman Vishnevskiy position'),
    info: [
      t('Roman Vishnevskiy info 1'),
      t('Roman Vishnevskiy info 2'),
      t('Roman Vishnevskiy info 3'),
      t('Roman Vishnevskiy info 4'),
    ],
  },
  {
    img: radchenko,
    imgBig: radchenkoBig,
    name: t('Anatoly Radchenko'),
    positionInCompany: t('Anatoly Radchenko position'),
    info: [
      t('Anatoly Radchenko info 1'),
      t('Anatoly Radchenko info 2'),
      t('Anatoly Radchenko info 3'),
      t('Anatoly Radchenko info 4'),
    ],
    followers: 65600,
    channel: t('YouTube'),
    channelLink: 'https://www.youtube.com/user/AnatoliiRadchenko',
  },
  {
    img: belousov,
    imgBig: belousovBig,
    name: t('Dmitry Belousov'),
    positionInCompany: t('Dmitry Belousov position'),
    info: [
      t('Dmitry Belousov info 1'),
      t('Dmitry Belousov info 2'),
      t('Dmitry Belousov info 3'),
      t('Dmitry Belousov info 4'),
    ],
  },
  {
    img: kurdyukov,
    imgBig: kurdyukovBig,
    name: t('Alexander Kurdyukov'),
    positionInCompany: t('Alik Kurdyukov position'),
    info: [
      t('Alexander Kurdyukov info 1'),
      t('Alexander Kurdyukov info 2'),
      t('Alexander Kurdyukov info 3'),
      t('Alexander Kurdyukov info 4'),
      t('Alexander Kurdyukov info 5'),
      t('Alexander Kurdyukov info 6'),
      t('Alexander Kurdyukov info 7'),
    ],
  },
  {
    img: butin,
    name: t('Yaroslav Butin'),
    positionInCompany: t('Yaroslav Butin position'),
  },
  {
    img: yuryev,
    name: t('Georgy Yuryev'),
    positionInCompany: t('Georgy Yuryev position'),
    followers: 6000,
    channel: t('Telegram'),
    channelLink: 'https://ttttt.me/beyondfinance',
  },
  {
    img: ofitserova,
    name: t('Daria Ofitserova'),
    positionInCompany: t('Daria Ofitserova position'),
    followers: 25900,
    channel: t('Telegram'),
    channelLink: 'https://ttttt.me/investinipo',
  },
  {
    img: markov,
    name: t('Aleksey Markov'),
    positionInCompany: t('Aleksey Markov position'),
  },
  {
    img: klevtsov,
    name: t('Anton Klevtsov'),
    positionInCompany: t('Anton Klevtsov position'),
    followers: 96000,
    channel: t('YouTube'),
    channelLink: 'https://www.youtube.com/user/klevtsovanton',
  },
];

// hack for preload big images and avoid transition glitch on partners modal
if (typeof document !== 'undefined') {
  const imgList = getPartners((v: string) => v)
    .map((partner) => partner.imgBig)
    .filter(Boolean) as string[];
  imgList.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
}
